import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import AvatarCustom from "./UserChat/AvatarCustom";
import moment from "moment";
import "moment/locale/pt-br";
import { getValue, getValueEnd } from "src/utils/util-get-values-string";
import { useLoadContext } from "src/contexts/LoadContext";
import ConversaService from "src/services/conversa/conversa.service";

const statusColors = {
  waiting: '#00d9a6',
  late: '#ffb347',
  veryLate: '#ff6b6b',
  avulso: '#7c8aff',
};

function getStatusInfo(minDiff, isPlantao, plantaoAtivado, isAvulso, setor) {
  if (isAvulso) return { label: 'AVULSO', color: statusColors.avulso };

  if (setor === 'suporte') {
    const isPlantaoAtivo = isPlantao() && plantaoAtivado;
    if (isPlantaoAtivo) {
      if (minDiff < 30) return { label: 'EM ESPERA', color: statusColors.waiting };
      if (minDiff < 45) return { label: 'ATRASADO', color: statusColors.late };
      return { label: 'MT ATRASADO', color: statusColors.veryLate };
    }
    if (minDiff < 10) return { label: 'EM ESPERA', color: statusColors.waiting };
    if (minDiff < 20) return { label: 'ATRASADO', color: statusColors.late };
    return { label: 'MT ATRASADO', color: statusColors.veryLate };
  }

  if (minDiff < 1440) return { label: 'EM ESPERA', color: statusColors.waiting };
  return { label: 'ATRASADO', color: statusColors.late };
}

function getScheduleStatus(dataAgendamento) {
  if (!dataAgendamento) return null;
  const now = moment();
  const scheduled = moment(dataAgendamento);
  const diffMin = now.diff(scheduled, 'minutes');

  if (diffMin < -30) return { label: 'AGENDADO', color: '#7c8aff', icon: 'ri-calendar-check-line', diffMin };
  if (diffMin < 0) return { label: 'EM BREVE', color: '#ffd166', icon: 'ri-alarm-line', diffMin };
  if (diffMin < 10) return { label: 'AGORA', color: '#00d9a6', icon: 'ri-alarm-warning-line', diffMin };
  if (diffMin < 30) return { label: 'ATRASADO', color: '#ffb347', icon: 'ri-error-warning-line', diffMin };
  return { label: 'MT ATRASADO', color: '#ff6b6b', icon: 'ri-alarm-warning-fill', diffMin };
}

function ChatsItem(props) {
  let { chat, activeChat, openUserChat, isTabTodas, isTabAgenda, agendamentoResposta, openAllSchedulesForNumber } = props;
  const { isPlantao, plantaoAtivado, user } = useLoadContext();
  const [minDiff, setminDiff] = useState();
  const [diffAtrasado, setDiffAtrasado] = useState(0);
  const [currentChat, setCurrentChat] = useState(chat);

  function isValido() {
    return user.setor === "suporte"
      && !currentChat.isAvulso
      && !currentChat.isAgendamento
      && !currentChat.isAtrasado
      && !currentChat.dataAtraso
      && !currentChat.inicioAtendimento
      && currentChat.isFilaEspera
  }

  function atendimentoAtrasado() {
    const validacaoPlantao = isPlantao() && plantaoAtivado;
    return (validacaoPlantao && diffAtrasado >= 45) || (!validacaoPlantao && diffAtrasado >= 10);
  }

  function calcDiff() {
    let dt = chat.createdAt;
    const horarioInicio = moment().set("hour", 8).set("minute", 0);
    const horarioFinalOntem = moment().set("hour", 22).set("minute", 0).set("days", -1);
    if (moment(chat.createdAt).isBetween(moment(horarioFinalOntem), moment(horarioInicio)))
      dt = horarioInicio;
    setminDiff(
      moment().diff(chat.isAgendamento ? chat.dataAgendamento : dt, "minutes")
    );
    const dataHoraAtual = moment().format("YYYY-MM-DD HH:mm:ss");
    const dataAgendamento = moment(chat.isAgendamento ? chat.dataAgendamento : dt).format("YYYY-MM-DD HH:mm:ss");
    const diff = moment(dataHoraAtual).diff(moment(dataAgendamento), 'minutes');
    setDiffAtrasado(diff);
  }

  useEffect(() => {
    calcDiff();
  }, [chat.isAgendamento, chat.dataAgendamento, chat.createdAt]);

  useEffect(() => {
    const interval = setInterval(() => { calcDiff(); }, 1000 * 30);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const updateAtrasado = async () => {
      if (atendimentoAtrasado() && isValido())
        setCurrentChat(await ConversaService.updateAtrasado(chat));
    };
    updateAtrasado();
  }, [diffAtrasado, chat]);

  const getMsg = (text) => {
    if (chat.chat.lastMsgText.includes("VCARD")) {
      let a = text.split("\n");
      let name = getValue("N:;", ";;;", text, 3);
      let number = "";
      a.forEach((item) => {
        if (item.includes("waid=")) number = getValueEnd("waid=", item, 5);
        if (item.includes("N:;") && item.includes(";;;"))
          name = getValue("N:;", ";;;", item, 3);
        else if (item.includes("FN:")) name = getValueEnd("FN:", item, 3);
      });
      return `Contato: ${name} ${number.split(":")[1]}`;
    }
    return text;
  };

  async function verificaChat(activeChat) {
    await ConversaService.verificaConversa(activeChat._id);
  }

  const isActive = activeChat && activeChat._id === chat._id;
  const hasUnread = chat.unreadMsg > 0;

  const noResponseMin = (chat.lastMsgFrom === "contato" && chat.lastMsg && chat.inicioAtendimento)
    ? Math.floor((Date.now() - new Date(chat.lastMsg).getTime()) / 60000)
    : 0;

  const isNonResponse = noResponseMin >= 5;

  const urgencyLevel = noResponseMin >= 15 ? 'critical' : noResponseMin >= 10 ? 'high' : noResponseMin >= 5 ? 'medium' : '';

  const waitingNoOwner = chat.isFilaEspera && !chat.userOwner;
  const waitingMin = waitingNoOwner
    ? Math.floor((Date.now() - new Date(chat.createdAt).getTime()) / 60000)
    : 0;
  const waitUrgency = waitingMin >= 20 ? 'critical' : waitingMin >= 10 ? 'high' : '';

  const scheduleStatus = (isTabAgenda && chat.isAgendamento && chat.dataAgendamento)
    ? getScheduleStatus(chat.dataAgendamento)
    : null;
  const scheduleUrgency = scheduleStatus
    ? (scheduleStatus.diffMin >= 30 ? 'critical' : scheduleStatus.diffMin >= 10 ? 'high' : scheduleStatus.diffMin >= 0 ? 'medium' : '')
    : '';

  const chatName = chat.isAvulso
    ? `${chat.nomeRequisitante ? `${chat.userRequisitante ? chat.userRequisitante.name : ""} | ${chat.nomeRequisitante}` : ""}`
    : chat.userDestino ? chat.userDestino.name : chat.name;

  const statusInfo = chat.isFilaEspera && !chat.userOwner
    ? getStatusInfo(minDiff, isPlantao, plantaoAtivado, chat.isAvulso, user.setor)
    : null;

  return (
    <li
      key={chat._id}
      id={"conversation" + chat._id}
      className={
        (isActive ? "active " : "") +
        (hasUnread ? "unread " : "") +
        (chat.isTyping ? "typing " : "") +
        (isNonResponse ? "non-response-time " : "") +
        (urgencyLevel ? `urgency-${urgencyLevel} ` : "") +
        (waitUrgency ? `wait-urgency-${waitUrgency} ` : "") +
        (scheduleUrgency ? `schedule-urgency-${scheduleUrgency} ` : "")
      }
    >
      <Link
        to="#"
        onClick={(e) => {
          if (activeChat || openUserChat) openUserChat(e, chat);
          if (agendamentoResposta) openAllSchedulesForNumber(agendamentoResposta);
        }}
      >
        <div className="d-flex align-items-center">
          <AvatarCustom
            chat={{
              ...chat,
              pfpUrl: chat.userDestino ? chat.userDestino.avatarUrl : chat.pfpUrl,
            }}
            isStaticImage={false}
            width={48}
            avatarSize="avatar-sm"
          />

          <div className="flex-1 overflow-hidden" style={{ minWidth: 0 }}>
            <div className="d-flex justify-content-between align-items-center">
              <h5 className="text-truncate mb-0" style={{ fontSize: 14, fontWeight: 600, flex: 1, minWidth: 0, display: 'flex', alignItems: 'center', gap: 4 }}>
                <span style={{ overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', minWidth: 0 }}>
                  {chatName}
                </span>
                {chat.novo && (
                  <span style={{ flex: 'none', fontSize: 9.5, fontWeight: 900, letterSpacing: '.05em', color: '#fff', background: '#e02424', padding: '2px 7px', borderRadius: 999, textTransform: 'uppercase' }}>
                    Novo
                  </span>
                )}
                {isNonResponse && (
                  <i className="ri-alarm-warning-line gzap-urgency-icon--pulse" style={{
                    fontSize: 13,
                    color: urgencyLevel === 'critical' ? '#ff6b6b' : urgencyLevel === 'high' ? '#ffb347' : '#ffd166',
                  }}></i>
                )}
              </h5>
              <div className="d-flex align-items-center" style={{ marginLeft: 8, flexShrink: 0 }}>
                {chat && !chat.isVerificado && chat.setor === "comercial" && !agendamentoResposta && (
                  <i
                    className="ri-error-warning-fill"
                    style={{ color: '#ffb347', fontSize: 16, marginRight: 4, cursor: 'pointer' }}
                    onClick={(e) => { e.preventDefault(); verificaChat(chat); }}
                  ></i>
                )}
                {isNonResponse && (
                  <span className="gzap-no-response-badge">
                    {noResponseMin}min
                  </span>
                )}
                {hasUnread && (
                  <span style={{
                    background: '#00d9a6',
                    color: '#0a0f1f',
                    borderRadius: 10,
                    padding: '1px 7px',
                    fontSize: 11,
                    fontWeight: 700,
                    minWidth: 20,
                    textAlign: 'center',
                  }}>
                    {chat.unreadMsg}
                  </span>
                )}
              </div>
            </div>

            <div className="d-flex align-items-center" style={{ marginTop: 2 }}>
              <div className="text-truncate flex-1" style={{ fontSize: 13, opacity: 0.7, minWidth: 0 }}>
                {chat.isTyping ? (
                  <span style={{ color: '#00d9a6', fontWeight: 500 }}>
                    digitando
                    <span className="animate-typing">
                      <span className="dot ms-1"></span>
                      <span className="dot ms-1"></span>
                      <span className="dot ms-1"></span>
                    </span>
                  </span>
                ) : chat.chat && (
                  <span className="d-flex align-items-center" style={{ gap: 4 }}>
                    {chat.chat.lastMsgFrom === 'contato' ? (
                      <i className="ri-arrow-left-down-line" style={{ color: '#00d9a6', fontSize: 12, flexShrink: 0 }}></i>
                    ) : (
                      <i className="ri-arrow-right-up-line" style={{ color: '#7c8aff', fontSize: 12, flexShrink: 0 }}></i>
                    )}
                    {chat.chat.isLastMsgImage ? (
                      <span><i className="ri-image-fill me-1"></i>Imagem</span>
                    ) : chat.chat.isLastMsgVideo ? (
                      <span><i className="ri-video-fill me-1"></i>Vídeo</span>
                    ) : chat.chat.isLastMsgFile ? (
                      <span><i className="ri-file-list-3-line me-1"></i>Documento</span>
                    ) : chat.chat.isLastMsgAudio ? (
                      <span><i className="ri-mic-line me-1"></i>Áudio</span>
                    ) : chat.chat.isLastMsgSticker ? (
                      <span><i className="ri-mickey-fill me-1"></i>Figurinha</span>
                    ) : chat.chat.lastMsgText ? (
                      <span className="text-truncate" style={{ minWidth: 0 }}>
                        {getMsg(chat.chat.lastMsgText)}
                      </span>
                    ) : null}
                  </span>
                )}
              </div>
              {chat.lastMsg && (
                <span className="gzap-chat-time">
                  {moment(chat.lastMsg).fromNow(true)}
                </span>
              )}
            </div>

            <div className="d-flex align-items-center justify-content-between" style={{ marginTop: 2 }}>
              <div className="d-flex align-items-center" style={{ gap: 6, minWidth: 0, flex: 1 }}>
                {isTabTodas && chat.userOwner && (
                  <span className="gzap-chat-owner">
                    <i className="ri-user-line"></i>
                    {chat.userOwner.name}
                  </span>
                )}

                {isTabAgenda && scheduleStatus && (
                  <span className="gzap-schedule-badge" style={{
                    color: scheduleStatus.color,
                    background: `${scheduleStatus.color}15`,
                    borderColor: `${scheduleStatus.color}25`,
                  }}>
                    <i className={`${scheduleStatus.icon} ${scheduleStatus.diffMin >= 0 ? 'gzap-urgency-icon--pulse' : ''}`}></i>
                    {scheduleStatus.label}
                    {scheduleStatus.diffMin >= 0 && (
                      <span className="gzap-schedule-badge__time">
                        {scheduleStatus.diffMin < 60
                          ? `${scheduleStatus.diffMin}min`
                          : `${Math.floor(scheduleStatus.diffMin / 60)}h${scheduleStatus.diffMin % 60}m`}
                      </span>
                    )}
                  </span>
                )}

                {isTabAgenda && chat.dataAgendamento && (
                  <span className="gzap-chat-schedule">
                    <i className="ri-calendar-check-line"></i>
                    {moment(chat.dataAgendamento).format("DD/MM HH:mm")}
                  </span>
                )}

                {!isTabAgenda && !isTabTodas && chat.isAgendamento && !chat.userOwner && (
                  <span className="gzap-chat-schedule">
                    <i className="ri-calendar-check-line"></i>
                    {chat.dataAgendamento ? moment(chat.dataAgendamento).format("DD/MM HH:mm") : ""}
                  </span>
                )}

                {chat.motivoAgendamento && isTabAgenda && (
                  <span className="gzap-schedule-motivo" title={chat.motivoAgendamento}>
                    {chat.motivoAgendamento.length > 25
                      ? chat.motivoAgendamento.substring(0, 25) + '...'
                      : chat.motivoAgendamento}
                  </span>
                )}
              </div>

              {((isTabTodas || chat.userOwner !== null) && chat.inicioAtendimento) || user.setor === "comercial" ? (
                <span className="gzap-chat-started">
                  {user.setor === "comercial" ? (
                    agendamentoResposta
                      ? moment(agendamentoResposta.horarioAgendamento).format("DD/MM HH:mm")
                      : moment(chat.lastMsg).fromNow(true)
                  ) : (
                    moment(chat.inicioAtendimento).fromNow(true)
                  )}
                </span>
              ) : null}

              {chat.isFilaEspera && !chat.userOwner && (
                <div className="d-flex align-items-center" style={{ gap: 6 }}>
                  <span className="gzap-chat-wait">
                    <i className="ri-timer-line"></i>
                    {minDiff < 60 ? `${minDiff}min` : minDiff < 1440 ? `${Math.floor(minDiff / 60)}h${minDiff % 60 > 0 ? `${minDiff % 60}m` : ''}` : `${Math.floor(minDiff / 1440)}d`}
                  </span>
                  {statusInfo && (
                    <span className="gzap-chat-status" style={{
                      color: statusInfo.color,
                      background: `${statusInfo.color}18`,
                    }}>
                      {statusInfo.label}
                    </span>
                  )}
                </div>
              )}

              {chat && chat.setor === "comercial" && agendamentoResposta && (
                <span style={{ fontSize: 11, opacity: 0.7 }}>
                  {agendamentoResposta.mensagem}
                </span>
              )}
            </div>
          </div>
        </div>
      </Link>
    </li>
  );
}

export default React.memo(ChatsItem);
